module.exports = __webpack_public_path__ + "img/download-icon.192594be.svg";